<!--  -->
<template>
  <div>
    <div class="container" v-if="isVerify">
        <div class="container-title" >{{title}}</div>
        <img src="../../assets/product/fetal-monitor.png" alt="多体征许可证" v-if="pageType == 1">
        <img src="../../assets/product/multiple-signs.png" alt="胎监许可证" v-if="pageType == 2">
    </div>
    <div class="container-fail" v-if="!isVerify">
        <div>没权限访该页面内容</div>
        <div>请回到首页支付或切换账号登录</div>
    </div>
</div>
</template>

<script>
  export default {
    name: '',
    data() {
      return {
        pageType: 0,
        title: '',
        isVerify: false
      }
    },

    props: [],

    watch: {},

    components: {},

    computed: {},

    created() {
      let userInfo = localStorage.getItem('userInfo') ? localStorage.getItem('userInfo') : '{}'
      userInfo = JSON.parse(userInfo)
      if (userInfo.email==window.Glod.superAdmin.email) {
        this.isVerify = true
        if (this.$route.query.pageType) {
            this.pageType = this.$route.query.pageType
            this.title = this.$route.query.title
        }
      } else {
        this.isVerify = false
        this.$toast('你没有权限访问该页面内容')
      }
    },

    methods: {}
  }

</script>
<style lang='scss' scoped>
  .container {
    padding: 30px;
    max-width: 650px;
    margin: 30px auto;
    background: #eee;

    .container-title {
        font-size: 36px;
        font-weight:bold;
        padding-bottom: 30px;
        color: #666;
    }

    img {
        width: 100%;
    }
  }

  .container-fail {
    background: #eee;
    padding: 30px;
    width: 400px;
    font-size: 22px;
    border-radius: 10px;
    margin: 40vh auto;
    // display:flex;
    // align-items:center;
    // justify-content:center;
    // flex-direction: column;
    color: red;
    div {
        margin-bottom:10px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/product/product.vue